import { Avatar, Box, Button, FormHelperText, FormControlLabel, Checkbox, Grid, IconButton, Paper, Stack, TextField, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { useState } from "react";
import moment from "moment";
import * as React from 'react';
import { useDispatch } from "store";
import { useCreateInvoiceCommentMutation } from 'store/slices/apis/invoiceApiSlice';
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';
import * as Yup from 'yup';
import { useParams } from "react-router-dom";

export default function AddInvoiceComment(props) {
    const { id, data } = props;
    const { projectId } = useParams()
    const dispatch = useDispatch();
    const formikRef = React.useRef();
    const [createInvoiceComment, { isLoading }] = useCreateInvoiceCommentMutation();

    const [formData, setFormData] = React.useState({
        Comment: '',
    });

    const validationSchema = Yup.object({
        Comment: Yup.string().required("Comment field is required.")
    });
    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {

        const hasCommentData = values.Comment.trim() !== '';

        if (hasCommentData) {
            let reqBody = {
                projectId: projectId,
                invoiceApprovalId: data?.invoiceApprovalId,
                comments: values?.Comment,
            };
            try {
                const response = await createInvoiceComment(reqBody).unwrap();
                openNotification("Comment added successfully", "success");
                resetForm();
            } catch (error) {
                openNotification("Failed to add comment", "error");
            }
        }
        setSubmitting(false);
    };


    return (
        <Formik
            innerRef={formikRef}
            initialValues={formData}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({
                values, errors, touched, handleChange, handleBlur,
                isSubmitting, setFieldValue, setTouched
            }) => (
                <Form>
                    <Paper sx={{ borderRadius: 2, boxShadow: 'none' }}>
                        <Stack spacing={1}>
                            <TextField
                                fullWidth
                                name="Comment"
                                value={values?.Comment}
                                onChange={handleChange}
                                onBlur={() => setTouched({ ...touched, Comment: true })}
                                multiline
                                rows={3}
                                placeholder="Write a Comment..."
                                InputProps={{
                                    sx: {
                                        // height: "50px",
                                        // borderRadius: "8px",
                                        backgroundColor: "#fff",

                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },

                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                        },
                                    },
                                }}
                            />
                            {touched?.Comment && errors?.Comment &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.Comment}`}</FormHelperText>
                            }

                            <Stack direction="row" spacing={1} alignItems="center">
                                <Box flexGrow={1} />
                                <Button type='submit'
                                    variant="contained"
                                    loading={isLoading}
                                    sx={{
                                        backgroundColor: "#00344C",
                                        borderRadius: "25px",
                                        textTransform: "none",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        lineHeight: "100%",
                                        fontFamily: "Outfit, sans-serif",
                                        color: "#FFFFFF",
                                        px: "20px",
                                        py: "15px",
                                    }}
                                >
                                    Comment
                                </Button>
                            </Stack>
                        </Stack>
                    </Paper>
                </Form>
            )
            }
        </Formik >
    );
}